// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drampa: PokeData = {
  "id": 780,
  "name": "drampa",
  "height": 30,
  "weight": 1850,
  "base_experience": 170,
  "types": [
    PokeType.NORMAL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "fly",
    "dragon-rage",
    "light-screen",
    "glare",
    "protect",
    "outrage",
    "safeguard",
    "dragon-breath",
    "twister",
    "hyper-voice",
    "extrasensory",
    "natural-gift",
    "dragon-pulse",
    "echoed-voice",
    "play-nice"
  ],
  "moves": [
    "protect",
    "outrage",
    "dragon-breath",
    "hyper-voice",
    "dragon-pulse",
    "body-slam",
    "draco-meteor",
    "quick-attack",
    "tri-attack",
    "dragon-claw",
    "dragon-fang",
    "refresh",
    "leer"
  ],
  "evolution_chain": {
    "id": 406,
    "item": null,
    "species": [
      {
        "name": "drampa",
        "order": 780,
        "types": [
          PokeType.NORMAL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 57,
    "ability_power": 213
  },
  "stat_changes": [],
  "catch_rate": 70,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
